/**
 * KAN-746: блок сделок клиента по режиму кабинета: у интернет-магазина
 * заказы. Новый режим = новая запись в реестре.
 * Пока настройки грузятся, блока нет (не мигает блоком другого режима).
 * KAN-811: у записи реестра запрос блока; закрытый пользователю (роль MANAGER,
 * заказы) блок не показывается и ничего не запрашивает.
 * KAN-987: сметы как продукт убраны: у режима "Услуги" (estimator) и при
 * неизвестном режиме записи нет, блок не рисуется и ничего не запрашивает.
 */
import type { ComponentType } from 'react';
import { useCanCallApi } from '@/hooks/useApiAccess';
import { useOrgModeState } from '@/hooks/useOrgMode';
import type { OrganizationMode } from '@/types/settings';
import { ClientOrdersCard } from './ClientOrdersCard';

interface DealsCardEntry {
  Card: ComponentType<{ clientId: string }>;
  /** Список, который блок загружает (GET), по id клиента. */
  listUrl: (clientId: string) => string;
}

const DEALS_CARDS: Partial<Record<OrganizationMode, DealsCardEntry>> = {
  ecommerce: { Card: ClientOrdersCard, listUrl: () => '/api/v1/orders/' },
};

function DealsCard({ entry, clientId }: { entry: DealsCardEntry; clientId: string }) {
  const allowed = useCanCallApi('GET', entry.listUrl(clientId));
  if (!allowed) return null;
  const { Card } = entry;
  return <Card clientId={clientId} />;
}

export function ClientDealsCard({ clientId }: { clientId: string }) {
  const { mode, isLoading } = useOrgModeState();
  const entry = mode ? DEALS_CARDS[mode] : undefined;
  if (isLoading || !entry) return null;
  return <DealsCard entry={entry} clientId={clientId} />;
}
